import {
  Checkbox,
  FormControlLabel,
  FormControlLabelProps,
} from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import { Text } from "$components";
import { CompanyServices } from "$services";
import { CacheInvalidationAction } from "$utils/cache";

type Props = {
  companyId: string;
  formControl: Control<any>;
  formFieldName: string; // react-hook-form name
} & Partial<FormControlLabelProps>;

function IsManageableCheckbox({
  companyId,
  formControl,
  formFieldName,
  ...formControlLabelProps
}: Props) {
  const { data: company } = useQuery({
    queryKey: [CacheInvalidationAction.GET_COMPANY_BY_ID, companyId],
    queryFn: () => CompanyServices.getCompanyById(companyId),
    enabled: !!companyId,
    staleTime: 60 * 1000,
  });

  return (
    <FormControlLabel
      control={
        <Controller
          control={formControl}
          name={formFieldName}
          render={({ field: { onChange, value } }) => (
            <Checkbox
              color="primary"
              onChange={(e) => onChange(e.target.checked)}
              checked={value}
            />
          )}
        />
      }
      label={
        <Text>
          Gérer le stock de{" "}
          <Text type="important" style={{ fontSize: "15px" }}>
            {company?.name}
          </Text>
        </Text>
      }
      {...formControlLabelProps}
    />
  );
}

export default IsManageableCheckbox;
